import { GiphyFetch } from "@giphy/js-fetch-api";

export const gf = new GiphyFetch("o0po4OdolMLQiYKYX0xlCsNBkRcjd0Co");
